import { safeboxClient } from 'myNet'

const ROUTE = '/v1/admin/workspace'
const ROUTE_WORKSPACES = '/v1/workspaces'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

const WorkspaceService = {
  updateDefaultQuota: async (defaultUserQuota: number): Promise<ApiResponse> => {
    const response = await safeboxClient.put(`${ROUTE}/default-user-quota`, {
      default_user_quota: defaultUserQuota,
    })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },

  requestUpgrade: async (workspaceName: string, userMessage?: string): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE_WORKSPACES}/upgrade-request`, {
      workspace_name: workspaceName,
      user_message: userMessage?.trim() || null,
    })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      // rate limit(429) 등 미들웨어 레벨 에러는 body 에 code 필드가 없으므로 HTTP status 로 폴백
      err.code = code ?? response.origin?.status
      throw err
    }
    return response.data
  },

  requestInquiry: async (
    workspaceName: string,
    contactEmail: string,
    message: string,
  ): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE_WORKSPACES}/inquiry`, {
      workspace_name: workspaceName || '',
      contact_email: contactEmail?.trim(),
      message: message?.trim(),
    })
    const { code, message: msg } = response.data
    if (code !== 200) {
      const err = new Error(msg) as ErrorWithCode
      // rate limit(429) 등 미들웨어 레벨 에러는 body 에 code 필드가 없으므로 HTTP status 로 폴백
      err.code = code ?? response.origin?.status
      throw err
    }
    return response.data
  },

  getResourceQuota: async (): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE_WORKSPACES}/resource-quota`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default WorkspaceService
